import gql from 'graphql-tag';
import { PRODUCT_THUMBNAIL, MOBILE_PRODUCT_THUMBNAIL } from '@components/ProductPage/ProductThumbnail/queries';

export const EXHIBITION = gql`
  ${PRODUCT_THUMBNAIL}
  ${MOBILE_PRODUCT_THUMBNAIL}
  query exhibition(
    $id: ID!
    $collectionCount: Int
    $collectionProductCount: Int
    $sortableProductCount: Int
    $isMgs: Boolean
    $after: String
    $isMobile: Boolean!
  ) {
    exhibition(id: $id) {
      id
      name
      isOpen
      image(size: 1800) @skip(if: $isMobile) {
        url
        alt
      }
      placeholderImage: image(size: 120) @skip(if: $isMobile) {
        url
        alt
      }
      imageMobile(size: 1200) @include(if: $isMobile) {
        url
        alt
      }
      placeholderImageMobile: imageMobile(size: 120) @include(if: $isMobile) {
        url
        alt
      }
      sections(first: $collectionCount, after: $after) {
        pageInfo {
          hasNextPage
          startCursor
          endCursor
        }
        edges {
          node {
            id
            name
            sectionType
            isPublished
            collection {
              id
              name
              slug
              isPublished
              products(first: $collectionProductCount, isMgs: $isMgs) {
                totalCount
                edges {
                  node {
                    ...productThumbnail @skip(if: $isMobile)
                    ...mobileProductThumbnail @include(if: $isMobile)
                  }
                }
              }
            }
            sortableProducts(first: $sortableProductCount, isMgs: $isMgs) {
              edges {
                node {
                  id
                  sortOrder
                  product {
                    ...productThumbnail @skip(if: $isMobile)
                    ...mobileProductThumbnail @include(if: $isMobile)
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
